import script from "./SIdentify.vue?vue&type=script&setup=true&lang=js"
export * from "./SIdentify.vue?vue&type=script&setup=true&lang=js"

import "./SIdentify.vue?vue&type=style&index=0&id=d10fd386&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d10fd386"]])

export default __exports__